import React, { useState } from 'react';
import { request } from '../../../functions/apiRequestHelper';
import { gtmPush } from '../../../functions/gtm';
import { validate } from '../../../functions/validation';
import Button from '../../../audi-ui-components/Button';
import Spinner from '../../../audi-ui-components/Spinner';
import Modal from '../../../audi-ui-components/Modal';
import TextField from '../../../audi-ui-components/TextField';

const EmailFormModal = ({ isActive, close, payload, theme }) => {
  
  const [emailAddress, setEmailAddress] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  
  const submitEmail = () => {
    let schema = {emailAddress: {
        presence: {
            message: "Email address is required",
            allowEmpty: false
        },
        email: {message: "Please enter a valid email address"}
    }};
    var v = validate({emailAddress: emailAddress}, schema, {format: "firstError", fullMessages: false});
    if (v && v.emailAddress) {
        setError(v.emailAddress);
    } else {
        setLoading(true);
        let _payload = Object.assign({}, payload, {
          email: emailAddress,
          firstName: firstName,
          lastName: lastName
        });
        request(`${process.env.RAZZLE_API_HOST}/1/afs/sendemail`, {
            method: "POST",
            body: JSON.stringify(_payload)
        }).then(response => {
            // console.log(response);
            gtmPush(
                "afsCalculator", "EmailSent", "AfsCalSummary",
                {"EmailAddress": emailAddress, "FirstName": firstName, "LastName": lastName}
            );
            setLoading(false); setSent(true);
            setTimeout(() => {
              close();
              setSent(false);
            }, 3000);
        }).catch(error => {
            console.error(error);
            setLoading(false);
        });
    }
  }
  
  return (
    <Modal isActive={isActive} modalStyle="layer" closeButton close={close}>
        <div className="position-relative">
            {loading && <div className="spinner-wrapper"><Spinner isContinuous /></div>}
            <TextField
                name="emailAddress"
                label="Email address"
                value={emailAddress}
                onChange={(v) => { setEmailAddress(v); setError(false); }}
                isInvalid={Boolean(error)}
                invalidMessage={error}
                className="mb-3"
                theme={theme === "dark" ? "light" : null}
            />
            <div className="row mb-4">
                <div className="col">
                    <TextField
                        name="firstName"
                        label="First name"
                        value={firstName}
                        onChange={(v) => { setFirstName(v); }}
                        className="mb-3"
                        theme={theme === "dark" ? "light" : null}
                    />
                </div>
                <div className="col">
                    <TextField
                        name="lastName"
                        label="Last name"
                        value={lastName}
                        onChange={(v) => { setLastName(v); }}
                        className="mb-3"
                        theme={theme === "dark" ? "light" : null}
                    />
                </div>
            </div>
            <Button label="Submit" buttonType="primary" onClick={submitEmail} theme={theme === "dark" ? "light" : null} />
            {sent && <p className="aui-color-text-green">Email sent</p>}
        </div>
    </Modal>
  );
}

export default EmailFormModal;
